import Nav from "./components/Nav";
import { Hero, PortalGrid } from "./components/Hero";
import HeatBoard from "./components/HeatBoard";
import { ZoneSection, FlipSection } from "./components/ZoneSections";
import Topics from "./components/Topics";
import { GuardRules, ReportCta } from "./components/Guard";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Nav />
      <main>
        <Hero />
        <PortalGrid />
        <HeatBoard />
        <ZoneSection />
        <FlipSection />
        <Topics />
        <GuardRules />
        <ReportCta />
      </main>
      <Footer />
    </div>
  );
}